export default __webpack_public_path__ + "static/media/8ebcf7edc98e58f2b5c6557459c2d985.jpg";